"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const RemoveAssignmentsButton_1 = require("../../../elements/RemoveAssignmentsButton");
function getStyle(flag, isCompletelyAssigned) {
    if (flag) {
        return {
            color: 'red',
            fontWeight: 'bold',
        };
    }
    else if (isCompletelyAssigned) {
        return { color: 'green', fontWeight: 'bold' };
    }
    else {
        return { color: 'black', fontWeight: 'normal' };
    }
}
function ZoneAssignmentColumn({ rowData, assignment, highlight, onHover, onClick, onUnlink, axis, rowSpanTags, }) {
    const diaIDs = rowData?.[axis].diaIDs || []; // diaIds at the level of zone
    const isAssignmentActive = assignment.isActive && assignment.activated?.axis === axis;
    const flag = isAssignmentActive ||
        (assignment.isOver && assignment.highlighted?.axis === axis) ||
        highlight.isActive;
    let totalNumberOfAtoms = rowData?.[axis]?.nbAtoms || 0;
    for (const signal of rowData?.signals || []) {
        totalNumberOfAtoms += signal?.[axis]?.nbAtoms || 0;
    }
    return ((0, jsx_runtime_1.jsx)("td", { ...rowSpanTags, ...onHover, onClick: (e) => onClick(e, assignment, axis), css: !isAssignmentActive && RemoveAssignmentsButton_1.removeAssignmentCssStyle, children: (totalNumberOfAtoms > 0 || isAssignmentActive) && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [totalNumberOfAtoms, " ", ' ( ', (0, jsx_runtime_1.jsx)("span", { style: getStyle(flag, false), children: diaIDs?.length || 0 }), ' ) ', (0, jsx_runtime_1.jsx)(RemoveAssignmentsButton_1.RemoveAssignmentsButton, { onClick: (e) => onUnlink(e, true, axis) })] })) }));
}
exports.default = ZoneAssignmentColumn;
